import React from 'react';

/**
 * El interruptor que pasa una grilla de selección ÚNICA a multi-select.
 *
 * Va ARRIBA de la grilla —no al pie, ni dentro de una card más— porque cambia el
 * significado de todos los taps que vienen después: hay que leerlo ANTES de empezar a
 * elegir (ADR-2026-08-28-catalogo-varios-modelos).
 *
 * Nació como "Utilizar varios modelos" y se generalizó cuando la grilla de POSES pidió
 * el mismo control (ADR-2026-09-04-las-poses-toman-el-interruptor-de-los-modelos): el
 * título y la bajada son props porque lo que cambia entre grillas es QUÉ se acumula y
 * qué consecuencia tiene —una imagen por modelo en Catálogo, todos en la misma foto en
 * Modelo, una imagen por pose en el picker de poses—; la forma del control es la misma y
 * duplicarla la dejaba divergiendo en el primer retoque.
 *
 * Vive suelto y compartido porque lo montan pantallas que NO comparten shell: el panel
 * del Catálogo (`PresetDetailSheet`), el de Modelo (`PresetDetailSheetModelo`), el sheet
 * de modelo de mobile (`ModelPicker`) y el de poses (`PosePicker`).
 */
export interface SwitchSeleccionMultipleProps {
  activo: boolean;
  onChange: (v: boolean) => void;
  /** El renglón en negrita: qué se puede elegir de a varios. */
  titulo: string;
  /**
   * La línea de abajo: qué pasa si se prende, cuántos van elegidos, o cómo salir cuando
   * el tope está lleno. La arma el caller porque el significado de "varios" cambia por
   * grilla.
   */
  bajada: string;
}

export const SwitchSeleccionMultiple: React.FC<SwitchSeleccionMultipleProps> = ({
  activo,
  onChange,
  titulo,
  bajada,
}) => (
  <button
    type="button"
    role="switch"
    aria-checked={activo}
    onClick={() => onChange(!activo)}
    className={`w-full mb-4 flex items-center gap-3 rounded-2xl border p-3 text-left transition-colors ${
      activo
        ? 'border-brand-primary bg-brand-primary/[0.06]'
        : 'border-black/10 hover:border-black/20 bg-white'
    }`}
  >
    {/* Interruptor y no un check: lo que se prende es un MODO de la grilla, no una
        opción más de su contenido. */}
    <span
      aria-hidden="true"
      className={`shrink-0 w-9 h-5 rounded-full p-0.5 transition-colors ${
        activo ? 'bg-brand-primary' : 'bg-black/15'
      }`}
    >
      <span
        className={`block w-4 h-4 rounded-full bg-white shadow-sm transition-transform ${
          activo ? 'translate-x-4' : 'translate-x-0'
        }`}
      />
    </span>
    <span className="min-w-0">
      <span className="block text-[14px] font-semibold text-brand-black">
        {titulo}
      </span>
      <span className="block text-[12px] leading-snug text-[#3C3C43]/60">
        {bajada}
      </span>
    </span>
  </button>
);

export default SwitchSeleccionMultiple;
